import { Component, OnInit, Inject, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar, MatDialog, getMatFormFieldDuplicatedHintError } from "@angular/material";
import { FormGroup, FormBuilder, Validators, FormControl, FormArray } from '@angular/forms';
import { ClipBoardService } from '../../../services/clipboard.service';
import { ServerService } from '../../../services/server.service';
import { DatePipe } from '@angular/common';
import { ClipBoardService as messageService } from "src/app/services/clipboard.service";

@Component({
  selector: 'app-escalation-status-modal',
  templateUrl: './escalation-status-modal.component.html',
  styleUrls: ['./escalation-status-modal.component.scss']
})
export class EscalationStatusModalComponent implements OnInit {

  authToken = localStorage.getItem("token");

  showComponentLoader: boolean = false;

  btnStatus: boolean = false

  myDateRangePickerOptions = {
    dateFormat: 'dd.mm.yyyy'
  };

  addForm: FormGroup;

  getEscalationCategory: any;

  currentDate: any = new Date();

  campaignData: any;

  //getEStatus:any = 'EMoveToProgress';
  //getEStatus: any = 'EMarkAsResolved';
  getEStatus: any;
  title:any;
  placeholder:any;
  constructor(
    private serverService: ServerService,
    private clipBoardService: ClipBoardService,
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
    private changeDetectorRef: ChangeDetectorRef,
    private dialog: MatDialog,
    private datePipe: DatePipe,
    private dialogRef: MatDialogRef<EscalationStatusModalComponent>,
    private clipBoardMessageService: messageService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.currentDate = new Date().toISOString().slice(0, 16); 
    this.campaignData = data
    // debugger
    // console.log(this.campaignData);
    if(this.campaignData.job_type_feedback == "creative_feedback"){
      this.placeholder = "Describe your feedback regarding the creative job."
      this.title = "Creative Job";
    }
    else if(this.campaignData.job_type_feedback == 'marketing_feedback'){
      this.title = "Marketing Job";
      this.placeholder = "Describe your feedback regarding the marketing job."
    }
    else{
      this.title = "Escalation";
      this.placeholder = "Describe your feedback regarding the action taken to resolve the issue."
    }
    if(data.new_status == 'In Progress'){
      this.getEStatus = 'EMoveToProgress';
    }
    else if(data.new_status == 'Resolved'){
      this.getEStatus = 'EMarkAsResolved';
    }
    else if(data.new_status == 'feedback'){
        this.getEStatus = 'EFeedback';
    }
    // else if(data.new_status == 'Resolved'){
    //   this.getEStatus = 'EMarkAsResolved'
    // }
    // console.log(data)
  }

  ngOnInit() {

    this.setDeliveryForm()

    if (this.getEStatus == 'EMoveToProgress') {
      this.addForm.get('actionItems').setValidators([Validators.required])
      this.addForm.get('actionItems').updateValueAndValidity()
      // this.addForm.get('results').setValidators([])
      // this.addForm.get('resolutionDate').setValidators([])
      // this.addForm.get('resolutionTime').setValidators([])
      // this.addForm.get('feedback').setValidators([])
    } else if(this.getEStatus == 'EMarkAsResolved') {
      // this.addForm.get("actionItems").setValidators([])
      this.addForm.get("results").setValidators([Validators.required])
      this.addForm.get('resolutionDate').setValidators([Validators.required])
      // this.addForm.get('resolutionTime').setValidators([Validators.required])
      this.addForm.get('results').updateValueAndValidity()
      this.addForm.get('resolutionDate').updateValueAndValidity()
      // this.addForm.get('resolutionTime').updateValueAndValidity()
      // this.addForm.get('feedback').setValidators([])
    } else if(this.getEStatus == 'EFeedback') {
      // this.addForm.get("actionItems").setValidators([])
      // this.addForm.get("results").setValidators([])
      // this.addForm.get('resolutionDate').setValidators([])
      // this.addForm.get('resolutionTime').setValidators([])
      this.addForm.get('feedback').setValidators([Validators.required])
      this.addForm.get('feedback').updateValueAndValidity()
    }
   

    
  }

  setDeliveryForm() {
    this.addForm = this.fb.group({
      actionItems: [''],
      results: [''],
      resolutionDate: [''],
      // resolutionTime: [''],
      feedback: [''],
    })
  }

  saveEscalationForm() {

    this.showComponentLoader = true;

    this.btnStatus = true;

    const formData: FormData = new FormData();

    formData.append('campaign_id', this.data.campaign_id);

    if (this.getEStatus == 'EMoveToProgress') {
      formData.append('action_items', this.addForm.value.actionItems);
      formData.append('status',this.data.new_status);
    }    

    if (this.getEStatus == 'EMarkAsResolved') {
      let resDateTime = this.addForm.value.resolutionDate;
      formData.append('results', this.addForm.value.results);
      formData.append('resolution_at', resDateTime);
      formData.append('status',this.data.new_status);
    }

    if (this.getEStatus == 'EFeedback' && this.campaignData.job_type_feedback == "escalation_feedback") {
      formData.append('resolution_feedback', this.addForm.value.feedback);
    }
    if(this.getEStatus == 'EFeedback' && this.campaignData.job_type_feedback == "creative_feedback"){
      formData.append('feedback', this.addForm.value.feedback); 
    }
    if(this.getEStatus == 'EFeedback' && this.campaignData.job_type_feedback == "marketing_feedback"){
      formData.append('feedback', this.addForm.value.feedback); 
    }
    // formData.append("completed_at", this.formatDateTime(''));
    // console.log(this.formatDateTime(this.createPresalesJob.value.completed_at));
    // formData.append("target_type", this.createPresalesJob.value.target_type);
    // formData.append("sourced_leads", this.createPresalesJob.value.source_leads);
    // formData.append("pitch", this.file, this.file.name);
    // formData.append("campaign_id", this.data);
    // formData.append("status", "Done");
    // formData.append('campaign_id',this.data.campaign_id)
    if(this.campaignData.job_type_feedback == "creative_feedback"){
      this.serverService.EStatusUpdateForm('campaign_module/creative_jobs/'+this.data.id, formData, this.authToken).subscribe(data => {
        // this.snackBar.open("Creative Job Feedback Updated Successfully", '', {
        //   duration: 1000,
        //   verticalPosition: 'top',
        //   horizontalPosition: 'end',
        //   panelClass: 'blue-snackbar'
        // })
        this.clipBoardMessageService.showMessgeInText(
          "Creative Job Feedback Updated Successfully",
          "success-snackbar"
        );
        this.btnStatus = false
        this.showComponentLoader = false;
        this.dialogRef.close(data)
      },
        err => {
          this.btnStatus = false
          this.showComponentLoader = false;
          this.clipBoardService.checkServerError(err, this.authToken)
        }
      )
    }
    else if(this.campaignData.job_type_feedback == "marketing_feedback"){
      this.serverService.EStatusUpdateForm('campaign_module/marketing_jobs/'+this.data.id, formData, this.authToken).subscribe(data => {
        // this.snackBar.open("Marketing Job Feedback Updated Successfully", '', {
        //   duration: 1000,
        //   verticalPosition: 'top',
        //   horizontalPosition: 'end',
        //   panelClass: 'blue-snackbar'
        // })
        this.clipBoardMessageService.showMessgeInText(
          "Marketing Job Feedback Updated Successfully",
          "success-snackbar"
        );
        this.btnStatus = false
        this.showComponentLoader = false;
        this.dialogRef.close(data)
      },
        err => {
          this.btnStatus = false
          this.showComponentLoader = false;
          this.clipBoardService.checkServerError(err, this.authToken)
        }
      )
    }
    else{
    this.serverService.EStatusUpdateForm('campaign_module/escalation/'+this.data.id, formData, this.authToken).subscribe(data => {
      // this.snackBar.open("Escalation Status Update Successfully", '', {
      //   duration: 1000,
      //   verticalPosition: 'top',
      //   horizontalPosition: 'end',
      //   panelClass: 'blue-snackbar'
      // })
      this.clipBoardMessageService.showMessgeInText(
        "Escalation Status Update Successfully",
        "success-snackbar"
      );
      this.btnStatus = false
      this.showComponentLoader = false;
      this.dialogRef.close(data)
    },
      err => {
        this.btnStatus = false
        this.showComponentLoader = false;
        this.clipBoardService.checkServerError(err, this.authToken)
      }
    )
  }
  }
  close() {
    this.dialogRef.close();
  }
 
}
